import * as React from "react";
import { Link } from "react-router-dom";
import { Patient } from "../../patient/types";

interface StoreProps {
  patient: Patient | null;
}

interface DispatchProps {}

interface OwnState {
  showMenu: boolean;
}

type Props = StoreProps & DispatchProps;

class ActionDropdown extends React.PureComponent<Props, OwnState> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected dropdownMenu: any;
  constructor(props: Props) {
    super(props);

    this.state = {
      showMenu: false
    };

    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public showMenu(event: any) {
    event.preventDefault();

    this.setState({ showMenu: true }, () => {
      document.addEventListener("click", this.closeMenu);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public closeMenu(event?: any) {
    if ((event && !this.dropdownMenu.contains(event.target)) || !event) {
      this.setState({ showMenu: false }, () => {
        document.removeEventListener("click", this.closeMenu);
      });
    }
  }

  public patientAction = () => {};

  render() {
    return (
      <div className="actionContainer">
        <i
          className="fas fa-ellipsis-h icon"
          onClick={this.showMenu}
          role="button"
          tabIndex={0}
        ></i>

        {this.state.showMenu ? (
          <div
            className="menu"
            ref={element => {
              this.dropdownMenu = element;
            }}
          >
            <div className="link">Send Confirmation Request</div>
            <div className="link">Message Patient</div>

            <div className="link">View Message Chain</div>
            <Link to={`/patient/`}>
              <div className="link" role="button" tabIndex={0}>
                View Patient Details and Communications
              </div>
            </Link>
          </div>
        ) : null}
      </div>
    );
  }
}

export default ActionDropdown;
